import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=c17b6020&scoped=true&"
import script from "./ErrorMessage.vue?vue&type=script&lang=ts&"
export * from "./ErrorMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorMessage.vue?vue&type=style&index=0&id=c17b6020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17b6020",
  null
  
)

export default component.exports